<template>
<svg viewBox="0 0 295 782" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio>
    <g id="whitechapel__bldgs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" :class="['hover-text-app-text trans-color-fast', {'text-app-accent': active}]" @mouseenter="$emit('hover')" @mouseleave="$emit('hoverEnd')">
        <g id="NewRdRes" transform="translate(118.000000, 338.000000)" fill="currentColor">
            <polygon id="Path-Copy-2" points="57.9531985 33 63 68.8842605 4.92532027 76 1 39.2392997"></polygon>
            <g id="4" font-family="Helvetica" font-size="24" font-weight="normal">
                <text>
                    <tspan x="0" y="23">4</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'SVG-WhitechapelBldgs',
  props: ['active']
}
</script>

<style>
</style>
